import {
  GET_POOLS,
  GET_POOLS_SUCCESS,
  GET_POOLS_ERROR,
  GET_POOL,
  GET_POOL_SUCCESS,
  GET_POOL_ERROR,
  PoolsState,
  initialState,
  PoolsActions,
  GET_POSTULANTES,
  GET_POSTULANTES_SUCCESS,
  GET_POSTULANTES_ERROR,
  CLEAR_DATA,
} from './types'

const PoolsReducer = (state: PoolsState = initialState, action: PoolsActions): PoolsState => {
  switch (action.type) {
    case GET_POOLS:
      return {
        ...state,
        loading: true,
        error: false,
      }
    case GET_POOLS_SUCCESS:
      return {
        ...state,
        pools: action.payload,
        loading: false,
        error: false,
      }
    case GET_POOLS_ERROR:
      return {
        ...state,
        pools: null,
        loading: false,
        error: true,
      }
    case GET_POOL:
      return {
        ...state,
        activePool: null,
        loading: true,
        error: false,
      }
    case GET_POOL_SUCCESS:
      return {
        ...state,
        activePool: action.payload,
        loading: false,
        error: false,
      }
    case GET_POOL_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      }
    case GET_POSTULANTES:
      return {
        ...state,
        pagination: null,
        loading: true,
        error: false,
      }
    case GET_POSTULANTES_SUCCESS:
      return {
        ...state,
        postulantes: [...state.postulantes, ...action.payload.profiles],
        pagination: action.payload.pagination,
        loading: false,
        error: false,
      }
    case GET_POSTULANTES_ERROR:
      return {
        ...state,
        pagination: null,
        loading: false,
        error: true,
      }
    case CLEAR_DATA:
      return {
        ...state,
        postulantes: [],
        activePool: null,
        pagination: null,
        loading: false,
        error: false,
      }
    default:
      return state
  }
}
export default PoolsReducer
